import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { AuditFormLightingTypePageContainer } from './audit-form-lighting-type-page.container';
import { useAuditFormLightingTypePageViewModel } from './audit-form-lighting-type-page.view-model';

export const AuditFormLightingTypePage = () => {
  const logger = useLogger('pages/audit-form-lighting-type');

  const viewModel = useAuditFormLightingTypePageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Lighting Types">
      <AuditFormLightingTypePageContainer
        viewModel={viewModel}
        logger={logger}
      />
    </NestedPageLayout>
  );
};
